import React, { useMemo, useRef, useState } from "react"
import styles from '../styles/walletDetails.module.scss'
import SpriteContainer from "@/wmCompoments/spriteContainer";
import { useTranslation } from "react-i18next";
import Icon from "@/wmCompoments/Icon";
import { IconName } from "@/wmCompoments/Icon/iconTypes";

const WalletDetails = ({data, allBalance})=>{
  const { t } = useTranslation('centralWallet')

  // 获取其它场馆余额
  const [showWalletInfo, setShowWalletInfo] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const amounts = useMemo(() => {
    return [
      {
        title: t('mainWallet'),
        value: data?.centerWalletBalance,
        icon: 'icon-mine-wallet'
      },
      {
        title: t('lockedWallet'),
        value: data?.lockedWalletBalance,
        icon: 'icon-lockWallet'
      },
      {
        title: t('benefitsCenter'),
        value: data?.centerWelfareBalance,
        icon: 'icon-benefitsCenter'
      }
    ]
  }, [data])

  return <div>
    
    <div className={styles.wallet_details} onClick={()=>{setShowWalletInfo(!showWalletInfo)}}>
      <div>{t('walletDetail')}</div>
      <div className={styles.view_details}>
        <span>{t('venueBalance')}</span>
        <SpriteContainer name={showWalletInfo ?'icon_minus_night' : 'icon_add_night' } module={'wallet'} />
      </div>
    </div>

    {/* 钱包明细列表 */}
    <div className={styles.details}
    style={{
      height: !showWalletInfo ? '0px' : Number(contentRef.current?.getBoundingClientRect().height) + 'px'
    }}
    >
      <div ref={contentRef}>
        <div className={styles.amounts}>
          {amounts?.map((v,index)=>{
            return <div key={index} className={styles.amounts_item}>
              <Icon name={v.icon as IconName} className={styles.item_icon} />
              <div>{v.title}<span>{v.value}</span></div>
            </div>
          })}
        </div>

        {allBalance?.length > 0 && <div className={styles.allBalance}>
          {allBalance.map((v,index)=>{
            return <div key={index} className={styles.allBalance_item}>
              <div>{v.channelName}</div>
              {v.status === 2 ? <div>{t('maintenance')}</div> : <div>{parseFloat(v.money).toFixed(2)}</div>}
            </div>
          })}
        </div>}
      </div>
    </div>
  </div>
}

export default WalletDetails